import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import Banner1 from "../images/g3.jpeg";

import Banner2 from "../images/g6.jpeg";
import Banner3 from "../images/g4.jpeg";

function Expirence() {
  const images = [
    { src: Banner1, alt: "Room and Suit 1" },
    { src: Banner2, alt: "Room and Suit 2" },
    { src: Banner3, alt: "Room and Suit 3" },
  ];

  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setInView(entry.isIntersecting);
      },
      { threshold: 0.5 }
    );

    const section = document.getElementById("expirence-section");
    if (section) observer.observe(section);

    return () => {
      if (section) observer.unobserve(section);
    };
  }, []);

  return (
    <Box id="expirence-section" sx={{
       mt: 8, overflow: "hidden" ,
       py: {sm: 0, md: 8}      



     }} >
     

      <Box 
  sx={{ 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
            // mb: 6,
          overflow: "hidden",
          mt: { sm: "8", xs:"8",  md: "2" }, // Adjust width based on screen size
  }}
>
  <Typography
    variant="h3"
    style={{
      fontFamily: "SangBleu Empire Trial",
      fontWeight: "bold",
      fontSize: "55px",
      lineHeight: "1",
      display: "inline-block",
    }}
    sx={{ mx: 2 }} // Add space on both sides of the text
  >
     Expirences
  </Typography>
  <Box
    sx={{
      width: '38px', // Length of the line
      height: '5px', // Thickness of the line
            backgroundColor: '#FF0000', // Color of the line
      mt:5,
    }}
  />
</Box>
      

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 3,
          mx: 8,
          my: {sm: 8, md: 0}, 
         
          alignItems: "center",
          flexDirection: { xs: "column", sm: "row" }, // Responsive layout
        }}
      >
        {/* Left Image - Zoom Out to 30% (scale: 0.7) */}
        <motion.div
          initial={{ y: 0, scale: 1 }}
          animate={inView ? { y: -40, scale: 1.3} : { y: 0, scale: 1 }}
          transition={{ duration: 0.8 }}
        >
          <Box
            component="img"
            src={images[0].src}
            alt={images[0].alt}
            sx={{
              width: { xs: "90%", sm: "100%" }, // Adjust width for different screen sizes
              height: "350px", // All images have the same height
              objectFit: "cover",
              pt: 12,
              mb:-16,
              borderRadius: "8px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          />
        </motion.div>

        {/* Center Image - Zoom In to 60% (scale: 1.6) */}
        <motion.div
          initial={{ y: 0, scale: 1 }}
          animate={inView ? { y: -40, scale: 1.1} : { y: 0, scale: 1 }}
          transition={{ duration: 0.8 }}
        >
          <Box
            component="img"
            src={images[1].src}
            alt={images[1].alt}
            sx={{
              width: { xs: "90%", sm: "100%" }, // Increase width for smaller screens
              height: "350px", // Same height for all images
              mt: {xs: 18},
              objectFit: "cover",
              borderRadius: "8px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
            }}
          />
        </motion.div>

        {/* Right Image - Zoom Out to 20% (scale: 0.8) */}
        <motion.div
          initial={{ y: 0, scale: 1 }}
          animate={inView ? { y: -30,  scale: 1.2} : { y: 0, scale: 1 }}
          transition={{ duration: 0.8 }}
        >
          <Box
            component="img"
            src={images[2].src}
            alt={images[2].alt}
            sx={{
              width: { xs: "90%", sm: "100%" }, // Adjust width for smaller screens
              height: "350px", // Same height for all images
              objectFit: "cover",
              pt:8,
              borderRadius: "8px",
              mt: {xs: -4},
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          />
        </motion.div>
      </Box>
    </Box>
  );
}

export default Expirence;
